<template>
  <div class="alert alert-sm bg--error" v-if="hasErrors">
    <div class="alert__body">
      <ul>
        <li v-for="error in errors">{{error}}</li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ErrorList',
    props: ['errors'],
    computed:{
      hasErrors:{
          get: function(){
              if (!this.errors){
                return false;
              }
              return this.errors.length > 0;
          }
      },
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/ErrorList.vue